import React from "react";
import { useNavigate } from "react-router-dom";


const NotFound = () => {

    const navigate = useNavigate()
    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #6D5DF6, #4FC3F7)",
                color: "#fff",
                textAlign: "center",
                padding: "20px",
                fontFamily: "Poppins, sans-serif",
            }}
        >
            <h1
                style={{
                    fontSize: "120px",
                    margin: "0",
                    fontWeight: "800",
                    animation: "bounce 1.6s infinite",
                }}
            >
                404
            </h1>

            <p style={{ fontSize: "24px", marginTop: "10px" }}>
                Oops! Page Not Found
            </p>

            <p style={{ fontSize: "16px", opacity: 0.9, marginTop: "5px" }}>
                The page you're looking for doesn’t exist or has been moved.
            </p>

            <button
                onClick={() => navigate("/user-login")}
                style={{
                    marginTop: "30px",
                    padding: "12px 28px",
                    background: "#fff",
                    color: "#333",
                    borderRadius: "30px",
                    fontSize: "16px",
                    fontWeight: "600",
                    textDecoration: "none",
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.2)",
                    border: "none",
                    cursor: "pointer",
                    transition: "0.3s",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
                Go Back
            </button>



            <style>
                {`
                @keyframes bounce {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-12px); }
                }
                `}
            </style>
        </div>
    );
};

export default NotFound;
